import { lngRole } from 'src/locales/sys_strings';
import { prototypeRoutes } from 'src/routes/prototype/_routes';
import { teacherRoutes } from 'src/routes/configs/teacher/routes';
import { adminRoutes } from 'src/routes/configs/admin/routes';
import { officerRoutes } from 'src/routes/configs/officer/routes';
import { accountantRoutes } from 'src/routes/configs/accountant/routes';
import { leaderRoutes } from 'src/routes/configs/leader/routes';
import { sellerRoutes } from 'src/routes/configs/seller/routes';
import { censorRoutes } from 'src/routes/configs/censor/routes';
import { showLog } from 'src/utils/debug-log';

export const useRRoutes = (rolecode, paths) => {
  showLog('rolecode =>', rolecode);

  if (rolecode) {
    if (rolecode === lngRole.teacher) {
      return teacherRoutes(paths);
    }
    if (rolecode === lngRole.officer) {
      return officerRoutes(paths);
    }
    if (rolecode === lngRole.accountant) {
      return accountantRoutes(paths);
    }
    if (rolecode === lngRole.leader) {
      return leaderRoutes(paths);
    }
    if (rolecode === lngRole.administrator) {
      return adminRoutes(paths);
    }
    if (rolecode === lngRole.seller) {
      return sellerRoutes(paths);
    }
    if (rolecode === lngRole.censor) {
      return censorRoutes(paths);
    }
    if (rolecode === lngRole.highest) {
      return prototypeRoutes(paths);
    }
  }
  return [];
};
